import { DateTime } from "@bps/date-time";
import { IDropdownOption } from "@bps/fluent-ui";

const createItem = (item: string) => {
  return { key: item, text: item, data: item };
};

export const medicareExpiryYears = (): IDropdownOption<string>[] => {
  const currentYear = DateTime.now().year;
  return [0, 1, 2, 3, 4, 5].map(i => {
    const yearString = (currentYear + i).toString();
    return createItem(yearString);
  });
};

export const allMonths = (): IDropdownOption<string>[] => {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map(month => {
    const monthString = month < 10 ? `0${month.toString()}` : month.toString();
    return createItem(monthString);
  });
};

export const irnNumbers = (): IDropdownOption<string>[] => {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9].map(n => createItem(n.toString()));
};

export const medicareExpiryFull = (): IDropdownOption<string>[] => {
  return medicareExpiryYears().flatMap(({ text: year }) => {
    return allMonths().map(({ text: month }) => {
      const item = createItem(`${year}-${month}`);
      item.text = `${month}/${year}`;
      return item;
    });
  });
};
